export const {
  VITE_API_HOST = 'http://localhost:8081',
  VITE_WEBSOCKET_HOST = 'ws://localhost:8081/ws',
  VITE_NOTIFICATION_HOST = 'ws://localhost:3000',
  VITE_APP = 'aiKO',
  VITE_GOOGLE_CLIENT_ID = '276997817575-cohh5jvl811r64isfs1m3nct81ebaq5s.apps.googleusercontent.com',
  VITE_GA_TRACKING_ID = 'G-4LBWD5RLLL',
} = import.meta.env;

export const HttpStatus = {
  Unauthorized: 401,
  Success: 200,
  Created: 201,
  BadRequest: 400,
  NotFound: 404,
  InternalServerError: 500,
  Training: 202,
};

export const ResourceType = {
  EXPERIENTIAL: 'experiential',
  PRIO_KNOWLEDGE: 'prio_knowledge',
  MEMORY: 'memory',
  PLAN: 'plan',
  FILE: 'file',
  INTERVIEW: 'interview',
  MCP: 'mcp',
  KNOWLEDGE_BASE: 'knowledge_base',
};

export const listAgentAvatar = [
  '/agent-avatar/agent-avatar-1.svg',
  '/agent-avatar/agent-avatar-2.svg',
  '/agent-avatar/agent-avatar-3.svg',
  '/agent-avatar/agent-avatar-4.svg',
  '/agent-avatar/agent-avatar-5.svg',
  '/agent-avatar/agent-avatar-6.svg',
  '/agent-avatar/agent-avatar-7.svg',
  '/agent-avatar/agent-avatar-8.svg',
  '/agent-avatar/agent-avatar-9.svg',
  '/agent-avatar/agent-avatar-10.svg',
  '/agent-avatar/agent-avatar-11.svg',
  '/agent-avatar/agent-avatar-12.svg',
  '/agent-avatar/agent-avatar-13.svg',
  '/agent-avatar/agent-avatar-14.svg',
  '/agent-avatar/agent-avatar-15.svg',
  '/agent-avatar/agent-avatar-16.svg',
  '/agent-avatar/agent-avatar-17.svg',
  '/agent-avatar/agent-avatar-18.svg',
  '/agent-avatar/agent-avatar-19.svg',
  '/agent-avatar/agent-avatar-20.svg',
  '/agent-avatar/agent-avatar-21.svg',
  '/agent-avatar/agent-avatar-22.svg',
  '/agent-avatar/agent-avatar-23.svg',
  '/agent-avatar/agent-avatar-24.svg',
  '/agent-avatar/agent-avatar-25.svg',
  '/agent-avatar/agent-avatar-26.svg',
  '/agent-avatar/agent-avatar-27.svg',
  '/agent-avatar/agent-avatar-28.svg',
  '/agent-avatar/agent-avatar-29.svg',
  '/agent-avatar/agent-avatar-30.svg',
];

export const ModelLLM = {
  'azureopenai-gpt-4.1': {
    name: 'AzureOpenAI-GPT-4.1',
    value: 'azureopenai-gpt-4.1',
    base_model: 'AzureOpenAI',
  },
  'openai-gpt-4.1': {
    name: 'GPT-4.1',
    value: 'openai-gpt-4.1',
    base_model: 'OpenAI',
  },
  'openai-gpt-4.1-mini': {
    name: 'GPT-4.1-mini',
    value: 'openai-gpt-4.1-mini',
    base_model: 'OpenAI',
  },
  // 'azureopenai-gpt-4o': {
  //   name: 'AzureOpenAI-GPT-4o',
  //   value: 'azureopenai-gpt-4o',
  //   base_model: 'AzureOpenAI',
  // },
  deepseek: {
    name: 'DeepSeek',
    value: 'deepseek',
    base_model: 'DeepSeek',
  },
  // 'gemini-2.5-flash': {
  //   name: 'Gemini-2.5-Flash',
  //   value: 'gemini-2.5-flash',
  //   base_model: 'Gemini',
  // },
  'llama-4-maverick': {
    name: 'Llama-4-Maverick',
    value: 'llama-4-maverick',
    base_model: 'Llama',
  },
  'qwen-turbo': {
    name: 'Qwen-turbo',
    value: 'qwen-turbo',
    base_model: 'Qwen',
  },
  // 'sonnet-3.7': {
  //   name: 'Sonnet-3.7',
  //   value: 'sonnet-3.7',
  //   base_model: 'Sonnet',
  // },
  'awssonnet-3.5': {
    name: 'AWS-Sonnet-3.5',
    value: 'awssonnet-3.5',
    base_model: 'AWS',
  },
};

export const MAX_CSV_XLSX_SIZE = 50 * 1024 * 1024; // 50MB in bytes
export const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB in bytes

export const ACCEPTED_FILE_TYPES = [
  'application/pdf',
  'text/plain',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.oasis.opendocument.text',
  'text/csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xlsx
  'text/markdown',
  'text/md',
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/tiff',
  'image/bmp',
  // "application/vnd.ms-excel", // xls
].join(', ');
